import { PRIMARY_DOMAIN } from 'environment';
import React from 'react';
import { Helmet } from 'react-helmet';

interface HelmetHelperProps {
  title?: string;
  description?: string;
  canonical?: string; // Always include a trailing slash
  image?: string;
}

const HelmetHelper: React.FC<HelmetHelperProps> = ({ title, description, canonical, image }) => {
  return (
    <Helmet>
      {title && title.length && <title>{title}</title>}
      {title && title.length && <meta property="og:title" content={title} />}
      {title && title.length && <meta property="og:site_name" content="Card.Gift" />}
      {description && description.length && <meta name="description" content={description} />}
      {canonical && canonical.length && <link rel="canonical" href={`https://${PRIMARY_DOMAIN}${canonical}`} />}
      {image && image.length && <meta property="og:image" content={image} />}
    </Helmet>
  );
};

export default HelmetHelper;
